import { render, staticRenderFns } from "./Medicamentos.vue?vue&type=template&id=69a21a9d"
import script from "./Medicamentos.vue?vue&type=script&lang=js"
export * from "./Medicamentos.vue?vue&type=script&lang=js"
import style0 from "./Medicamentos.vue?vue&type=style&index=0&id=69a21a9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports